import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

import Modulo13U3Act3 from "../../../DnD/modulo13U3Act3";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad2.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[2];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[3].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[3].path}`,
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[1].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[1].path}`,
  };

  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  const items = [
    <div className="selectable btn btn-red shadow mx-3 my-1">
      planificación
    </div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">ciudad</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">servicios</div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-4">
        <li>
          Coloca las palabras en el recuadro de la definición que les
          corresponda.
        </li>
      </ul>
      <Modulo13U3Act3 items={items} />

      <GuiaDocente>
        <ul>
          <li>
            Explique que trabajarán con palabras nuevas. El
            objetivo de las actividades está orientado, por un lado, a la
            definición de palabras vinculadas con el crecimiento de las ciudades
            y, por otro, a que los niños y niñas incorporen estas palabras a su
            vocabulario.
          </li>
          <li>
            Antes de empezar con la actividad, apunte las palabras
            “planificación”, “ciudad” y “servicios”. Indague sobre
            el conocimiento previo del niño o la niña. Por ejemplo, puede
            preguntarles:
            <ul>
              <li>
                <i>
                  “¿Saben el significado de estas palabras? ¿Las han escuchado
                  ya alguna vez? ¿Qué otras palabras parecidas conocen? Por
                  ejemplo: planificación, plan, planear; ciudad, ciudadano;
                  servicios, servicial, servir”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora, lea la primera indicación: Coloca las palabras en el recuadro
            de la definición que les corresponda. Pida a un o una estudiante que
            lea las palabras “planificación”, “ciudad” y “servicios” y a otro
            que lea los significados. Déles un tiempo para trabajar. Revise de
            manera conjunta sus respuestas.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
